import './legal-page.css';

const sections = [
  {
    title: '1. Giới thiệu dịch vụ',
    body: 'CIOC Running Club cung cấp nền tảng để người dùng tham gia các campaign chạy bộ, theo dõi tiến độ và kết nối tài khoản Strava để đồng bộ hoạt động liên quan đến campaign.',
  },
  {
    title: '2. Điều kiện sử dụng',
    body: 'Khi sử dụng ứng dụng, bạn đồng ý cung cấp thông tin chính xác, không sử dụng nền tảng cho mục đích gian lận, và tuân thủ các quy định áp dụng cho từng campaign hoặc hoạt động cộng đồng.',
  },
  {
    title: '3. Tài khoản và kết nối Strava',
    body: 'Một số tính năng yêu cầu bạn đăng nhập và cho phép kết nối Strava. Bạn chịu trách nhiệm với việc sử dụng tài khoản Strava của mình và có thể ngắt kết nối bất kỳ lúc nào từ cấu hình phù hợp.',
  },
  {
    title: '4. Dữ liệu hoạt động',
    body: 'Ứng dụng có thể sử dụng dữ liệu hoạt động, hồ sơ cơ bản và thông tin cần thiết từ Strava để hiển thị thành tích, bảng xếp hạng, tiến độ campaign và các tính năng liên quan đến vận động viên.',
  },
  {
    title: '5. Giới hạn trách nhiệm',
    body: 'Chúng tôi nỗ lực duy trì thông tin chính xác và dịch vụ ổn định nhưng không bảo đảm nền tảng luôn không gián đoạn hoặc không có lỗi. Người dùng cần tự đánh giá tính phù hợp của thông tin trước khi sử dụng.',
  },
  {
    title: '6. Cập nhật điều khoản',
    body: 'Điều khoản này có thể được cập nhật để phản ánh thay đổi về tính năng, yêu cầu pháp lý hoặc tích hợp bên thứ ba. Phiên bản cập nhật sẽ được công bố trên trang này.',
  },
];

export default function TermsAndConditionsPage() {
  return (
    <article className="legal-page">
      <span className="legal-page__eyebrow">Legal</span>
      <h1>Terms and Conditions</h1>
      <p className="legal-page__intro">
        Các điều khoản này mô tả cách người dùng truy cập và sử dụng nền tảng CIOC Running Club.
      </p>
      <p className="legal-page__effective">Effective date: July 27, 2026</p>

      <div className="legal-page__sections">
        {sections.map((section) => (
          <section className="legal-page__section" key={section.title}>
            <h2>{section.title}</h2>
            <p>{section.body}</p>
          </section>
        ))}
      </div>

      <p className="legal-page__contact">
        Nếu cần trao đổi thêm về điều khoản sử dụng, vui lòng liên hệ{' '}
        <a href="mailto:info@digitalleaders.coach">info@digitalleaders.coach</a>.
      </p>
    </article>
  );
}
